module.exports = __webpack_public_path__ + "static/media/fa-solid-900.adec7d6f.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free/webfonts/fa-solid-900.ttf
// module id = 283
// module chunks = 36